import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { BsPlus } from '@react-icons/all-files/bs/BsPlus'
import DateField from '../../fields/DateField/DateField'
import { routes } from '../../../constantes/routes'
import PlusBtn from '../../buttons/PlusBtn'
import Header from '../../header/Header'
import Search from '../../common/Search'
import EventsModal from '../EventsModal'
import TasksModal from '../../management/tasks/TasksModal'
import { eventosActions } from '../../../actions/eventosActions'
import { tasksActions } from '../../../actions/tasksActions'
import { phasesActions } from '../../../actions/phasesActions'
import { businessunitsActions } from '../../../actions/businessunitsActions'
import { hospitalsActions } from '../../../actions/hospitalsActions'
import { specialtiesActions } from '../../../actions/specialtiesActions'
import { onSubmitText } from '../../../constantes/onSubmitText'
import { swalAlertError, swalSuccessGeneral } from '../../../utils/swalAlert'
import { swalMssgs } from '../../../constantes/swalMssgs'
import { contactsApi } from '../../../api/contactsApi'
import { formatDateForInput } from '../../../utils/date'
import './seguimiento-comercial.scss'

const SeguimientoComercialContainer = () => {
  const history = useHistory()
  const dispatch = useDispatch()

  // Selectores Redux
  const phases = useSelector((state) => state.phases)
  const contacts = useSelector((state) => state.contacts)
  const tasks = useSelector((state) => state.tasks)
  const events = useSelector((state) => state.events)
  const businessunits = useSelector((state) => state.businessunits)
  const userProfile = useSelector((state) => state.userProfile || {})
  const hospitals = useSelector((state) => state.hospitals || [])
  const specialties = useSelector((state) => state.specialties || [])

  // Estados locales
  const [searchValue, setSearchValue] = useState('')
  const [localContacts, setLocalContacts] = useState([])
  const [activeDropdown, setActiveDropdown] = useState(null)
  const [localBusinessUnits, setLocalBusinessUnits] = useState([])
  const [eventos, setEventos] = useState([])

  // Estado para el modal de eventos
  const [newEvento, setNewEvento] = useState({
    nombre: '',
    fechaInicio: '',
    fechaFinal: '',
    descripcion: '',
    ubicacion: '',
    businessUnits: [],
  })
  const [modalIsOpen, setModalIsOpen] = useState(false)

  // Estado para el modal de tareas
  const [newTask, setNewTask] = useState({
    id_Usuario: '',
    id_TipoAsunto: '',
    id_TipoFase: '',
    id_Contacto: '',
    fecha: '',
    descripcion: '',
    asunto: '',
    id_Evento: '',
    isVerCaledario: false,
    id_NegocioUnidades: [],
    hospitales: '',
    especialidades: '',
  })
  const [taskModalIsOpen, setTaskModalIsOpen] = useState(false)
  const [isEditMode, setIsEditMode] = useState(false)
  const [taskToEdit, setTaskToEdit] = useState(null)

  // Acciones Redux
  const createEvento = (evento) => dispatch(eventosActions.createEvento(evento))
  const createTask = (task) => dispatch(tasksActions.newTask(task))
  const updateTask = (task) => dispatch(tasksActions.updateTask(task))
  const getAllPhases = () => dispatch(phasesActions.getAllPhases())
  const getAllTasks = () => dispatch(tasksActions.getAllTasks(0)) // Añadimos para cargar tareas
  const getAllEventos = () => dispatch(eventosActions.getAllEventos()) // Añadimos para cargar eventos
  const getAllBusinessUnits = () =>
    dispatch(businessunitsActions.getAllBusinessUnits())
  const getAllHospitals = () => dispatch(hospitalsActions.getAllHospitals())
  const getAllSpecialties = () =>
    dispatch(specialtiesActions.getAllSpecialties())

  // Función para manejar cambio de evento relacionado y actualizar unidades de negocio
  const handleEventoRelacionadoChange = (event) => {
    const { value } = event.target

    // Actualizar el campo del evento
    handleChangeNewTask(event)

    // Buscar y actualizar unidades de negocio
    if (value) {
      const selectedEvento = eventos.find(
        (evento) => evento.id_Evento === parseInt(value),
      )
      const unidades =
        selectedEvento && selectedEvento.id_NegocioUnidades
          ? selectedEvento.id_NegocioUnidades
          : []
      setLocalBusinessUnits(Array.isArray(unidades) ? unidades : [unidades])
    } else {
      setLocalBusinessUnits([])
    }
  }

  // Función para manejar cambios de fecha
  const handleDateChange = (event) => {
    // El DateField ya envía el evento con el formato correcto (YYYY-MM-DD)
    const { value } = event.target
    if (!value || /^\d{4}-\d{2}-\d{2}$/.test(value)) {
      handleChangeNewTask(event)
    }
  }

  const getAllContacts = async () => {
    try {
      const response = await contactsApi.getAllContacts()
      if (response && response.data) {
        setLocalContacts(response.data)
      }
    } catch (error) {
      console.error('Error loading contacts:', error)
    }
  }

  const retrieveEventos = async () => {
    try {
      const response = await getAllEventos()
      setEventos(response && response.payload ? response.payload : [])
    } catch (error) {
      console.error('Error loading eventos:', error)
      setEventos([])
    }
  }

  // Cargar datos al montar el componente
  useEffect(() => {
    getAllPhases()
    getAllContacts()
    getAllTasks() // Cargar tareas reales
    getAllEventos() // Cargar eventos
    getAllBusinessUnits()
    retrieveEventos()
    getAllHospitals()
    getAllSpecialties()
  }, [])

  // Efecto para cerrar dropdown al hacer clic fuera
  useEffect(() => {
    const handleDocumentClick = (event) => {
      if (
        !event.target.closest('.dropdown-container') &&
        !event.target.closest('.dropdown-form')
      ) {
        setActiveDropdown(null)
      }
    }

    if (activeDropdown) {
      document.addEventListener('click', handleDocumentClick)
    }

    return () => {
      document.removeEventListener('click', handleDocumentClick)
    }
  }, [activeDropdown])

  const toMain = () => {
    history.push(routes.MAIN)
  }

  const toEditTask = async (id) => {
    // Encontrar la tarea por ID y abrir el modal de edición
    const task = filteredTasks.find(
      (task) => task.id_Crm.toString() === id.toString(),
    )
    if (task) {
      openEditTaskModal(task)
    }
  }

  const onChangeSearch = (value) => {
    setSearchValue(value)
  }

  // Funciones para el modal de eventos
  const openNewEventModal = () => {
    setNewEvento({
      nombre: '',
      fechaInicio: '',
      fechaFinal: '',
      descripcion: '',
      ubicacion: '',
      businessUnits: [],
    })
    setModalIsOpen(true)
  }

  const closeEventModal = () => {
    setModalIsOpen(false)
    setNewEvento({
      nombre: '',
      fechaInicio: '',
      fechaFinal: '',
      descripcion: '',
      ubicacion: '',
      businessUnits: [],
    })
  }

  const handleChangeNewEvento = (event) => {
    const value = event.target.value
    const name = event.target.name
    setNewEvento({ ...newEvento, [name]: value })
  }

  const handleSubmitNewEvento = async (event) => {
    event.preventDefault()
    try {
      // Extraer IDs de business units con validación
      const businessUnitsIds =
        newEvento.businessUnits && Array.isArray(newEvento.businessUnits)
          ? newEvento.businessUnits
              .filter((bu) => bu && typeof bu.id_NegocioUnidad !== 'undefined')
              .map((bu) => bu.id_NegocioUnidad)
          : []

      const eventoData = {
        nombre: newEvento.nombre,
        descripcion: newEvento.descripcion,
        fechaInicio: newEvento.fechaInicio,
        fechaFinal: newEvento.fechaFinal,
        ubicacion: newEvento.ubicacion,
        id_NegocioUnidades: businessUnitsIds,
      }

      const response = await createEvento(eventoData)
      if (response && response.type && response.type.includes('SUCCESS')) {
        swalSuccessGeneral('Creado Correctamente', swalMssgs.NEW_SUCCES)
        closeEventModal()
        getAllEventos() // Recargar eventos
      }
    } catch (error) {
      swalAlertError(
        error.response && error.response.data
          ? error.response.data
          : 'Error al crear el evento',
      )
    }
  }

  const validateFormNewEvento = () => {
    return (
      newEvento.nombre &&
      newEvento.nombre.trim() !== '' &&
      newEvento.fechaInicio &&
      newEvento.fechaInicio.trim() !== '' &&
      newEvento.fechaFinal &&
      newEvento.fechaFinal.trim() !== '' &&
      newEvento.descripcion &&
      newEvento.descripcion.trim() !== '' &&
      newEvento.ubicacion &&
      newEvento.ubicacion.trim() !== '' &&
      newEvento.businessUnits.length > 0
    )
  }

  // Funciones para el modal de tareas
  const openNewTaskModal = () => {
    setNewTask({
      id_Usuario:
        userProfile && userProfile.id_Usuario ? userProfile.id_Usuario : '',
      id_TipoAsunto: '',
      id_TipoFase: '',
      id_Contacto: '',
      fecha: '',
      descripcion: '',
      asunto: '',
      id_Evento: '',
      isVerCaledario: false,
      id_NegocioUnidades: [],
      hospitales: '',
      especialidades: '',
    })
    setLocalBusinessUnits([])
    setIsEditMode(false)
    setTaskToEdit(null)
    setTaskModalIsOpen(true)
  }

  const openEditTaskModal = (task) => {
    setNewTask({
      id_Crm: task.id_Crm || '',
      id_Usuario: task.id_Usuario || '',
      id_Contacto: task.id_Contacto || '',
      id_TipoFase: task.id_TipoFase || '',
      id_TipoAsunto: task.id_TipoAsunto || '',
      id_Evento: task.id_Evento || '',
      asunto: task.asunto || '',
      fecha: formatDateForInput(task.fecha || ''),
      descripcion: task.descripcion || '',
      isVerCaledario: task.isVerCaledario || false,
      id_NegocioUnidades: task.id_NegocioUnidades || [],
      hospitales: task.hospitales || '',
      especialidades: task.especialidades || '',
    })
    setLocalBusinessUnits(task.id_NegocioUnidades || [])
    setIsEditMode(true)
    setTaskToEdit(task)
    setTaskModalIsOpen(true)
  }

  const closeTaskModal = () => {
    setTaskModalIsOpen(false)
    setIsEditMode(false)
    setTaskToEdit(null)
    setLocalBusinessUnits([])
    setNewTask({
      id_Usuario:
        userProfile && userProfile.id_Usuario ? userProfile.id_Usuario : '',
      id_TipoAsunto: '',
      id_TipoFase: '',
      id_Contacto: '',
      fecha: '',
      descripcion: '',
      asunto: '',
      id_Evento: '',
      isVerCaledario: false,
      id_NegocioUnidades: [],
      hospitales: '',
      especialidades: '',
    })
  }

const handleChangeNewTask = (eventOrArray) => {
    // Si recibimos un array de eventos, actualizamos todos los campos
    if (Array.isArray(eventOrArray)) {
      let updatedTask = { ...newTask }
      eventOrArray.forEach((event) => {
        const value =
          event.target.type === 'checkbox'
            ? event.target.checked
            : event.target.value
        const name = event.target.name

        // No permitir cambios en las unidades de negocio ya que son solo de lectura
        if (name === 'id_NegocioUnidades') {
          return
        }

        updatedTask = { ...updatedTask, [name]: value }
      })
      setNewTask(updatedTask)
      return
    }

    // Caso normal: un solo evento
    const value =
      eventOrArray.target.type === 'checkbox'
        ? eventOrArray.target.checked
        : eventOrArray.target.value
    const name = eventOrArray.target.name

    if (name === 'id_NegocioUnidades') {
      return
    }

    setNewTask({ ...newTask, [name]: value })
  }

  const handleSubmitNewTask = async (event) => {
    event.preventDefault()
    try {
      const taskData = {
        ...newTask,
        id_NegocioUnidades: newTask.id_NegocioUnidades || [],
      }

      if (isEditMode) {
        const response = await updateTask(taskData)
        if (response && response.type && response.type.includes('SUCCESS')) {
          swalSuccessGeneral(
            'Actualizado Correctamente',
            swalMssgs.UPDATE_SUCCES,
          )
          closeTaskModal()
          getAllTasks() // Recargar la lista de tareas
        } else {
          swalAlertError('Error al actualizar el lead')
        }
      } else {
        const response = await createTask(taskData)
        if (response && response.type && response.type.includes('SUCCESS')) {
          swalSuccessGeneral('Creado Correctamente', swalMssgs.NEW_SUCCES)
          closeTaskModal()
          getAllTasks() // Recargar la lista de tareas
        } else {
          swalAlertError('Error al crear el lead')
        }
      }
    } catch (error) {
      const errorMessage =
        error.response && error.response.data
          ? error.response.data
          : isEditMode
          ? 'Error al actualizar el lead'
          : 'Error al crear el lead'
      swalAlertError(errorMessage)
    }
  }

  const validateFormNewTask = () => {
    const isValid =
      newTask.id_Usuario &&
      newTask.id_Usuario.toString().trim() !== '' &&
      newTask.id_TipoAsunto &&
      newTask.id_TipoAsunto.toString().trim() !== '' &&
      newTask.id_TipoFase &&
      newTask.id_TipoFase.toString().trim() !== '' &&
      newTask.id_Contacto &&
      newTask.id_Contacto.toString().trim() !== '' &&
      newTask.fecha &&
      newTask.fecha.trim() !== '' &&
      newTask.descripcion &&
      newTask.descripcion.trim() !== '' &&
      newTask.asunto &&
      newTask.asunto.trim() !== ''

    return isValid
  }

  // Validación específica para el formulario del dropdown (sin id_TipoFase)
  const validateDropdownForm = () => {
    const isValid =
      newTask.id_Usuario &&
      newTask.id_Usuario.toString().trim() !== '' &&
      newTask.id_TipoAsunto &&
      newTask.id_TipoAsunto.toString().trim() !== '' &&
      newTask.id_Contacto &&
      newTask.id_Contacto.toString().trim() !== '' &&
      newTask.fecha &&
      newTask.fecha.trim() !== '' &&
      newTask.descripcion &&
      newTask.descripcion.trim() !== '' &&
      newTask.asunto &&
      newTask.asunto.trim() !== ''

    return isValid
  }

  const handleSubmitSeguimiento = async (event, phaseId) => {
    event.preventDefault()
    try {
      // businessUnits ya contiene los IDs directamente
      const { businessUnits, ...taskDataBase } = newTask
      const taskWithPhase = {
        ...taskDataBase,
        id_TipoFase: phaseId,
        id_NegocioUnidades: businessUnits || [],
      }

      const response = await createTask(taskWithPhase)
      if (response && response.type && response.type.includes('SUCCESS')) {
        swalSuccessGeneral('Creado Correctamente', swalMssgs.NEW_SUCCES)
        setActiveDropdown(null)
        // Resetear formulario
        setNewTask({
          id_Usuario:
            userProfile && userProfile.id_Usuario ? userProfile.id_Usuario : '',
          id_TipoAsunto: '',
          id_TipoFase: '',
          id_Contacto: '',
          fecha: '',
          descripcion: '',
          asunto: '',
          businessUnits: [],
        })
        getAllTasks() // Recargar tareas
      }
    } catch (error) {
      swalAlertError(
        error.response && error.response.data
          ? error.response.data
          : 'Error al crear el lead',
      )
    }
  }

  // const renderStars = (count = 3) => {
  //   return '★'.repeat(count)
  // }

  // Función para calcular el total de tareas por fase
  const calculatePhaseTotal = (phaseId) => {
    const phaseTasks = filteredTasks.filter(
      (task) => task.id_TipoFase === phaseId,
    )
    return phaseTasks.length
  }

  // Filtrar tareas según búsqueda (igual que en CRM)
  const filteredTasks = tasks.filter(
    (task) =>
      searchValue === '' ||
      (task.asunto &&
        task.asunto.toLowerCase().includes(searchValue.toLowerCase())) ||
      (task.descripcion &&
        task.descripcion.toLowerCase().includes(searchValue.toLowerCase())) ||
      (task.contactos &&
        task.contactos.nombre &&
        task.contactos.nombre
          .toLowerCase()
          .includes(searchValue.toLowerCase())),
  )

  const createNewFollowUp = (phaseId) => {
    const newActiveDropdown = activeDropdown === phaseId ? null : phaseId

    // Si se está abriendo un nuevo dropdown, limpiar el formulario
    if (newActiveDropdown !== null && activeDropdown !== phaseId) {
      setNewTask({
        id_Usuario:
          userProfile && userProfile.id_Usuario ? userProfile.id_Usuario : '',
        id_TipoAsunto: '',
        id_TipoFase: '',
        id_Contacto: '',
        fecha: '',
        descripcion: '',
        asunto: '',
        businessUnits: [],
      })
    }

    setActiveDropdown(newActiveDropdown)
  }

  // Componente del dropdown convertido a formulario
  const renderDropdown = (phaseId) => {
    if (activeDropdown !== phaseId) return null
    return (
      <div className='dropdown-form' onClick={(e) => e.stopPropagation()}>
        <form onSubmit={(e) => handleSubmitSeguimiento(e, phaseId)}>
          <div className='form-field'>
            <label htmlFor={`asunto-${phaseId}`}>Asunto</label>
            <input
              type='text'
              id={`asunto-${phaseId}`}
              name='asunto'
              value={newTask.asunto}
              onChange={handleChangeNewTask}
              placeholder='Asunto del lead'
              required
            />
          </div>

          <div className='form-field'>
            <label htmlFor={`tipoAsunto-${phaseId}`}>Tipo de Asunto</label>
            <select
              id={`tipoAsunto-${phaseId}`}
              name='id_TipoAsunto'
              value={newTask.id_TipoAsunto}
              onChange={handleChangeNewTask}
              required
            >
              <option value=''>Seleccionar tipo de asunto</option>
              {events && events.length > 0
                ? events.map((event) => (
                    <option
                      key={event.id_TipoAsunto}
                      value={event.id_TipoAsunto}
                    >
                      {event.nombre}
                    </option>
                  ))
                : null}
            </select>
          </div>

          <div className='form-field'>
            <label htmlFor={`descripcion-${phaseId}`}>Descripción</label>
            <input
              type='text'
              id={`descripcion-${phaseId}`}
              name='descripcion'
              value={newTask.descripcion}
              onChange={handleChangeNewTask}
              placeholder='Descripción'
              required
            />
          </div>

          <div className='form-field'>
            <label htmlFor={`contacto-${phaseId}`}>Contacto</label>
            <select
              id={`contacto-${phaseId}`}
              name='id_Contacto'
              value={newTask.id_Contacto}
              onChange={handleChangeNewTask}
              required
            >
              <option value=''>Seleccionar contacto</option>
              {(localContacts.length > 0 ? localContacts : contacts).map(
                (contact) => (
                  <option key={contact.id_Contacto} value={contact.id_Contacto}>
                    {contact.nombre}
                  </option>
                ),
              )}
            </select>
          </div>

          <div className='form-field'>
            <label htmlFor={`fecha-${phaseId}`}>Fecha</label>
            <DateField
              name='fecha'
              value={newTask.fecha || ''}
              onChange={handleDateChange}
              required={true}
            />
          </div>

          <div className='form-field'>
            <label htmlFor={`eventoRelacionado-${phaseId}`}>
              Evento Relacionado
            </label>
            <select
              id={`eventoRelacionado-${phaseId}`}
              name='id_Evento'
              value={newTask.id_Evento || ''}
              onChange={handleEventoRelacionadoChange}
            >
              <option value=''>Seleccionar evento</option>
              {eventos && eventos.length > 0
                ? eventos.map((evento) => (
                    <option key={evento.id_Evento} value={evento.id_Evento}>
                      {evento.nombre}
                    </option>
                  ))
                : null}
            </select>
          </div>

          <div className='form-field'>
            <label>Unidades de Negocio</label>
            <div
              style={{
                minHeight: '32px',
                display: 'flex',
                flexWrap: 'wrap',
                gap: '3px',
                alignItems: 'flex-start',
                padding: '4px 0',
              }}
            >
              {localBusinessUnits.length > 0 ? (
                localBusinessUnits.map((unitId) => {
                  const unit = businessunits.find(
                    (bu) => bu.id_NegocioUnidad === unitId,
                  )
                  return (
                    <span
                      key={unitId}
                      style={{
                        backgroundColor: '#00a499',
                        color: '#1a202c',
                        padding: '2px 6px',
                        borderRadius: '8px',
                        fontSize: '10px',
                        fontWeight: '500',
                      }}
                    >
                      {unit ? unit.nombre : `Unidad ${unitId}`}
                    </span>
                  )
                })
              ) : (
                <span style={{ color: '#6c757d', fontStyle: 'italic' }}>
                  Selecciona un evento para ver las unidades de negocio
                </span>
              )}
            </div>
          </div>

          <div className='form-actions'>
            <button
              type='button'
              className='btn-cancel'
              onClick={() => setActiveDropdown(null)}
            >
              Cancelar
            </button>
            <button
              type='submit'
              className='btn-submit'
              disabled={!validateDropdownForm()}
            >
              Guardar
            </button>
          </div>
        </form>
      </div>
    )
  }

  return (
    <div className='products'>
      <Header text={'Seguimiento comercial'} route={toMain} backBtn={true} />
      <div className='filter__wrap mb-80'>
        <Search onChangeSearch={onChangeSearch} placeholder='Buscar...' />
        <div className='btn-container'>
          <button
            title='Nuevo Lead'
            className='action-button' onClick={openNewTaskModal}>
            <PlusBtn />
            <span>Nuevo Lead</span>
          </button>
          <button className='action-button' title="Crear Evento" onClick={openNewEventModal}>
            <PlusBtn />
            <span>Crear Evento</span>
          </button>
        </div>
      </div>
      <div
        className='seguimiento-kanban'
        style={{
          '--column-count': phases && phases.length ? phases.length : 1,
        }}
      >
        {/* Headers */}
        <div className='seguimiento-kanban__headers'>
          {phases &&
            phases.map((phase) => (
              <div
                key={phase.id_TipoFase}
                className='seguimiento-kanban__header'
              >
                <div className='seguimiento-table__titles'>
                  <div>{phase.nombre}</div>
                  <div className='dropdown-container'>
                    {/* <BsGear /> */}
                    <BsPlus
                      size={20}
                      fill='#ED8B00'
                      onClick={(e) => {
                        e.stopPropagation()
                        createNewFollowUp(phase.id_TipoFase)
                      }}
                    />
                  </div>
                </div>
                {renderDropdown(phase.id_TipoFase)}
                <div className='column-total'>
                  {calculatePhaseTotal(phase.id_TipoFase)} leads
                </div>
              </div>
            ))}
        </div>

        {/* Content Columns */}
        <div className='seguimiento-kanban__columns'>
          {phases &&
            phases.map((phase) => (
              <div
                key={phase.id_TipoFase}
                className='seguimiento-kanban__column'
              >
                {filteredTasks
                  .filter((task) => task.id_TipoFase === phase.id_TipoFase)
                  .map((task) => (
                    <div
                      className='seguimiento-table__card'
                      key={task.id_Crm}
                      onClick={() => toEditTask(task.id_Crm)}
                    >
                      <div>{task.asunto || 'Sin asunto'}</div>
                      <div>{task.descripcion || 'Sin descripción'}</div>
                      <div>{task.hospitales || 'Sin hospitales'}</div>
                      <div>
                        {task.contacto ? task.contacto : 'Sin contacto'}
                      </div>
                      <div>{task.fecha.split(' ')[0]}</div>
                      {/* <div className='card-priority-stars'>
                        Prioridad {renderStars()}
                      </div> */}
                    </div>
                  ))}
              </div>
            ))}
        </div>
      </div>

      {/* Modal para crear evento */}
      <EventsModal
        modalIsOpen={modalIsOpen}
        closeModal={closeEventModal}
        inputs={newEvento}
        handleChange={handleChangeNewEvento}
        handleSubmit={handleSubmitNewEvento}
        validateForm={validateFormNewEvento}
        textBtn={onSubmitText.Crear}
        businessunits={businessunits}
        isEdit={false}
      />

      <TasksModal
        modalIsOpen={taskModalIsOpen}
        closeModal={closeTaskModal}
        inputs={newTask}
        handleChange={handleChangeNewTask}
        handleSubmit={handleSubmitNewTask}
        validateForm={validateFormNewTask}
        textBtn={isEditMode ? onSubmitText.Guardar : onSubmitText.Crear}
        phases={phases}
        contacts={localContacts.length > 0 ? localContacts : contacts}
        events={events}
        businessunits={businessunits}
        hospitals={hospitals}
        specialties={specialties}
        isEdit={isEditMode}
        taskToEdit={taskToEdit}
        onTaskUpdated={getAllTasks}
      />
    </div>
  )
}

export default SeguimientoComercialContainer
